<section id="chatbot" class="chatbot-teaser">
  <div class="chatbot__content">
    <h2>{{ 'CHATBOT.TITLE' | translate }}</h2>
    <p>{{ 'CHATBOT.DESCRIPTION' | translate }}</p>

<p style="color:white; font-weight:600;">{{ 'CHATBOT_EXAMPLES.TITLE' | translate }}</p>

<div class="example-question">
  <button class="example-button" style="max-width: 300px;" (click)="setPrompt('CHATBOT_EXAMPLES.MODERNIZE_ANGULAR')">
    {{ 'CHATBOT_EXAMPLES.MODERNIZE_ANGULAR' | translate }}
  </button>
  <button class="example-button" style="max-width: 300px;" (click)="setPrompt('CHATBOT_EXAMPLES.ARCHITEKTUR')">
    {{ 'CHATBOT_EXAMPLES.ARCHITEKTUR' | translate }}
  </button>
  <button class="example-button" style="max-width: 300px;" (click)="setPrompt('CHATBOT_EXAMPLES.CLOUD_READY')">
    {{ 'CHATBOT_EXAMPLES.CLOUD_READY' | translate }}
  </button>
</div>

      

    <div style="display: flex; justify-content: center; margin-top: 20px;">
      <div class="chat-container">
        <h2>{{ 'CHATBOT.CHAT_TITLE' | translate }}</h2>
        <div class="chat-history" *ngIf="chatHistory.length">
          <div *ngFor="let message of chatHistory">
            <div [ngClass]="{
              'user-message': message.role === 'user',
              'assistant-message': message.role === 'assistant'
            }">
              <p>{{ message.content }}</p>
            </div>
          </div>
        </div>
        <textarea [(ngModel)]="prompt" [placeholder]="'CHATBOT.PLACEHOLDER' | translate"
                  rows="3" class="chat-input"></textarea>
        <button (click)="send()" class="cta-button" style="border: none;">{{ 'CHATBOT.SEND' | translate }}</button>
      </div>
    </div>


  </div>
</section>